import React, { Component, PropTypes } from 'react'
import withCdnUrl from './withCdnUrl'

export class QuadColumn extends Component {
  render() {
    return (
      <section>
        <div className="container">
          <div className="section__head--noPara">
            <h2>What we’ve been up to</h2>
          </div>
          <div className="section__body">
            <div className="row timeline">
              <div className="column--fourth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-la.gif`} />
                  <div className="meta">
                    <p>Founded in 2017 by Delane Parnell in LA</p>
                    <div className="year">2017</div>
                  </div>
                </div>
              </div>
              <div className="column--fourth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-key.gif`} />
                  <div className="meta">
                    <p>Partnered with the NFHS and signed contracts with top game publishers</p>
                    <div className="year">2018</div>
                  </div>
                </div>
              </div>
              <div className="column--fourth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-15m.gif`} />
                  <div className="meta">
                    <p>Raised a $15.5M Series A led by NEA</p>
                  </div>
                </div>
              </div>
              <div className="column--fourth">
                <div className="card">
                  <img src={`${this.props.cdnUrl}images/illustrations/pvs-30m.gif`} />
                  <div className="meta">
                    <p>
                      Raised a $30.5M Series B Led by Elysian Park Ventures, the private investment arm of the
                      Los Angeles Dodgers{' '}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default withCdnUrl(QuadColumn)



// WEBPACK FOOTER //
// ./src/common/ui/components/quadColumn__timeline.js